import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Eye, Radio } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg, imgSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TierGate } from "@/components/Guards";

function GoLive() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  if (user.role_type !== "sugar_baby" && user.role !== "admin") return null;
  const start = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/cams/go-live", { title }); nav(`/cams/${data.id}`); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={start} className="card-lux mb-10 flex flex-col gap-3 p-5 sm:flex-row sm:items-center" data-testid="go-live-form">
      <Radio className="h-5 w-5 text-red-500" />
      <Input data-testid="go-live-title-input" required placeholder="Name your show…" value={title} onChange={(e) => setTitle(e.target.value)} className="flex-1 bg-zinc-900" />
      <button data-testid="go-live-btn" className="btn-red rounded-full px-6 py-2.5 text-sm font-semibold">Go live</button>
      {user.id_status !== "verified" && <span className="text-xs text-zinc-500">Requires ID verification</span>}
    </form>
  );
}

export default function Cams() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => { api.get("/cams").then((r) => setRooms(r.data)); }, []);
  return (
    <main className="mx-auto max-w-7xl px-5 py-12 lg:px-8" data-testid="cams-page">
      <p className="eyebrow mb-3">VIP · Live now</p>
      <h1 className="font-display mb-10 text-5xl sm:text-6xl">Live <span className="italic text-red-600">cams</span></h1>
      <TierGate tier="vip" title="Live cams are for VIPs">
        <GoLive />
        {rooms.length === 0 && <p className="text-zinc-500">No one is live right now.</p>}
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rooms.map((r) => (
            <Link key={r.id} to={`/cams/${r.id}`} data-testid={`cam-room-${r.id}`} className="card-lux group relative block overflow-hidden">
              <img src={imgSrc(r.host?.photo)} alt="" className="aspect-video w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent" />
              <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded bg-red-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest"><span className="live-dot h-1.5 w-1.5 rounded-full bg-white" />Live</span>
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded bg-black/60 px-2 py-0.5 text-xs"><Eye className="h-3 w-3" />{r.viewers}</span>
              <div className="absolute bottom-0 p-4"><p className="font-display text-2xl">{r.host?.name}</p><p className="text-xs text-zinc-400">{r.title}</p></div>
            </Link>
          ))}
        </div>
      </TierGate>
    </main>
  );
}
